import { Typography } from '@mui/material';
import { field } from '../types';

type props = {
	cField: field;
};

export default function Label(props: props) {
	const { label, value } = props.cField.props;

	const getFormattedLabelWithParams = (): string => {
		if (!value) {
			return label || '';
		}
		const params = (value as string).split(',');
		let formattedLabel = label || '';

		params.forEach((value, index) => {
			formattedLabel = formattedLabel.replaceAll(`{${index.toString()}}`, value);
		});

		return formattedLabel;
	};

	return <Typography>{getFormattedLabelWithParams()}</Typography>;
}
